module.exports = __webpack_public_path__ + "media/images/mySweetWed_logo-9b0894f0d0544053f2021575c11aee37.svg";